export const TitleStyle = {
  display: "flex",
  justifyContent: "center",
 };
